"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var systemAdminApi = _interopRequireWildcard(require("@/api/systemadmin.js"));
var _validate = require("@/utils/validate");
var _toolsValidate = require("@/utils/toolsValidate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default2 = exports.default = {
  // name: "edit"
  components: {},
  props: {
    isCreate: {
      type: Number,
      required: 0
    },
    editData: {
      type: Object,
      default: function _default() {
        return {
          rules: []
        };
      }
    }
  },
  data: function data() {
    var _this = this;
    var confirmvalidatePass = function confirmvalidatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.pwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入管理员密码'));
      } else {
        if (_this.pram.repwd !== '') {
          _this.$refs.pram.validateField('repwd');
        }
        callback();
      }
    };
    return {
      constants: this.$constants,
      pram: {
        account: null,
        pwd: '',
        repwd: '',
        realName: null,
        roles: [],
        status: null,
        id: null,
        phone: null
      },
      roleList: [],
      rules: {
        account: [{
          required: true,
          message: '请填写管理员账号',
          trigger: ['blur', 'change']
        }],
        pwd: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }, {
          required: true,
          min: 6,
          max: 20,
          message: '长度6-20个字符'
        }],
        repwd: [{
          required: true,
          validator: confirmvalidatePass,
          trigger: ['blur', 'change']
        }],
        realName: [{
          required: true,
          message: '请填写管理员姓名',
          trigger: ['blur', 'change']
        }],
        roles: [{
          required: true,
          message: '请选择管理员身份',
          trigger: ['blur', 'change']
        }],
        phone: [{
          validator: _toolsValidate.validatePhone,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.handleGetRoleList();
  },
  methods: {
    close: function close() {
      this.$emit('hideEditDialog');
    },
    handleGetRoleList: function handleGetRoleList() {
      var _this2 = this;
      var _pram = {
        page: 1,
        limit: this.constants.page.limit[4],
        status: 1
      };
      roleApi.getRoleList(_pram).then(function (data) {
        _this2.roleList = data;
        var arr = [];
        data.list.forEach(function (item) {
          arr.push(item.id);
        });
        if (!arr.includes(Number.parseInt(_this2.pram.roles))) {
          _this2.$set(_this2.pram, 'roles', []);
        }
      });
    },
    initEditData: function initEditData() {
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        account = _this$editData.account,
        realName = _this$editData.realName,
        roles = _this$editData.roles,
        level = _this$editData.level,
        status = _this$editData.status,
        id = _this$editData.id,
        phone = _this$editData.phone;
      this.pram.account = account;
      this.pram.realName = realName;
      var _roles = [];
      if (roles && roles.length > 0 && !roles.includes(',')) {
        //如果权限id集合有长度并且是只有一个，就将它Push进_roles这个数组
        _roles.push(Number.parseInt(roles));
      } else {
        //否则就将多个id集合解构以后push进roles并且转换为整型
        _roles.push.apply(_roles, _toConsumableArray(roles.split(',').map(function (item) {
          return Number.parseInt(item);
        })));
      }
      this.pram.roles = _roles;
      this.pram.status = status;
      this.pram.id = id;
      this.pram.phone = phone;
      this.rules.pwd = [];
      this.rules.repwd = [];
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this3 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this3.isCreate === 0) {
          _this3.handlerSave();
        } else {
          _this3.handlerEdit();
        }
      });
    }),
    handlerSave: function handlerSave() {
      var _this4 = this;
      systemAdminApi.adminAdd(this.pram).then(function (data) {
        _this4.$message.success('创建管理员成功');
        _this4.$emit('hideEditDialog');
      });
    },
    handlerEdit: function handlerEdit() {
      var _this5 = this;
      this.pram.roles = this.pram.roles.join(',');
      systemAdminApi.adminUpdate(this.pram).then(function (data) {
        _this5.$message.success('更新管理员成功');
        _this5.$emit('hideEditDialog');
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    }
  }
};